<template>
  <main>
    <crumbs :crumbs="crumbs"></crumbs>
    <div class="wrap">
      <div class="result">
        <div class="clear branch">
          <div class="swiper-container" id="swiper-branch">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in branch" @click="changeTab(item,index)">
                <div class=" item" :style="{backgroundImage:'url('+util.autoImage((tab.id == item.id ? item.bg2 : item.bg))+')'}"
                     :class="[tab.id == item.id ? 'active' : '']">
                  <div class="cen">
                    <div class="middle">
                      <div class="icon"><img :src="util.autoImage(item.icon)" alt=""></div>
                      <div class="icon icon-a"><img :src="util.autoImage(item.image)" alt=""></div>
                      <div class="tit">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear session">
          <div class="list" :class="[tab.id == item.id ? 'active' : '']" v-for="(item,index) in branch">
            <div class="title-box"><span>08/21</span>{{ item.min_title }}</div>
            <div class="description">{{ item.desc }}</div>
            <div class="box">
              <div class="clear item fuck-your-sister" v-for="(v,i) in item.list" :class="[tool.array.inArray(live_active,sessionStatus(item,v,i)) ? 'active' : '']"
                   @click="toMudu(item,v,i)">
                <div class=" time-box">
                  <div class="line line-1"></div>
                  <div class="left time">{{ tool.date.formatDate("H:i", v.live_start) }}-{{ tool.date.formatDate("H:i", v.live_end) }}</div>
                  <div class="line line-2"></div>
                </div>
                <div class=" info-box">
                  <div class=" info">
                    <div class="title">{{ v.title }}</div>
                    <div class="speaker">
                      <div class="ll" v-if="v.speaker"><span>{{ v.speaker }}</span><i v-if="v.speaker_job">|</i><span>{{ v.speaker_job }}</span></div>
                      <div class="ll" v-if="v.speaker2"><span>{{ v.speaker2 }}</span><i v-if="v.speaker2_job">|</i><span>{{ v.speaker2_job }}</span></div>
                      <div class="ll" v-if="v.speaker3"><span>{{ v.speaker3 }}</span><i v-if="v.speaker3_job">|</i><span>{{ v.speaker3_job }}</span></div>
                      <div class="ll" v-if="v.speaker4"><span>{{ v.speaker4 }}</span><i v-if="v.speaker4_job">|</i><span>{{ v.speaker4_job }}</span></div>
                    </div>
                    <div class="status-box">
                      <div class="status" :class="[tool.array.inArray(live_active,sessionStatus(item,v,i)) ? 'active' : '']">
                        <p>{{ statusText(sessionStatus(item, v, i)) }}</p>
                      </div>
                      <div class="star" :class="[inStar(v) ? 'active' : '']" @click.stop="star(v,item)">
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
<!--              <template v-if="tab_index <= 2">-->
<!--                <div class="clear item" @click="toBanner">-->
<!--                  <div class=" time-box">-->
<!--                    <div class="line line-1"></div>-->
<!--                    <div class="left time" v-show="tab_index === 0">17:00-17:20</div>-->
<!--                    <div class="left time" v-show="tab_index === 1">16:35-16:57</div>-->
<!--                    <div class="left time" v-show="tab_index === 2">16:45-17:07</div>-->
<!--                    <div class="line line-2"></div>-->
<!--                  </div>-->
<!--                  <div class=" info-box">-->
<!--                    <div class=" info">-->
<!--                      <div class="title">AMD：绿色算力－开创数据中心新格局</div>-->
<!--                      <div class="status-box">-->
<!--                        <div class="status" :class="[banner_status >= 2 ? 'active' : '']">-->
<!--                          <p>{{ banner_status === 1 ? "敬请期待" : banner_status === 2 ? "正在直播" : "直播回放" }}</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="clear item" @click="toBanner">-->
<!--                  <div class=" time-box">-->
<!--                    <div class="line line-1"></div>-->
<!--                    <div class="left time" v-show="tab_index === 0">17:20-17:35</div>-->
<!--                    <div class="left time" v-show="tab_index === 1">16:57-17:13</div>-->
<!--                    <div class="left time" v-show="tab_index === 2">17:07-17:23</div>-->
<!--                    <div class="line line-2"></div>-->
<!--                  </div>-->
<!--                  <div class=" info-box">-->
<!--                    <div class=" info">-->
<!--                      <div class="title">NVIDIA AI</div>-->
<!--                      <div class="status-box">-->
<!--                        <div class="status" :class="[banner_status >= 2 ? 'active' : '']">-->
<!--                          <p>{{ banner_status === 1 ? "敬请期待" : banner_status === 2 ? "正在直播" : "直播回放" }}</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </template>-->
            </div>
          </div>
        </div>
      </div>
      <div class=" s5" v-show="adv4.length > 0" style="display:none">
        <div class="center">
          <div class="b1"></div>
          <div class="common-title">
            <div class="left title">解锁超多精彩内容3</div>
            <div class="left en-title">SNEAK PEEK</div>
          </div>
          <div class="content">
            <div class="list">
              <div class="item" v-for="(item,index) in adv4" v-if="index < 4" @click="showVideo(item)">
                <div class="image-box">
                  <div class="image"
                       :style="{backgroundImage:'url('+(item.image ? util.autoImage(item.image): util.autoImage(item.url)+'?x-oss-process=video/snapshot,t_0,f_jpg,m_fast')+')'}">
                    <div class="play"></div>
                  </div>
                </div>
                <div class="info">
                  <div class="tit">{{ item.category_title }}</div>
                  <div class="element-more min-tit
">{{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="more">
            <div class="btn" @click="util.toLink('/video')"><span>查看更多</span></div>
          </div>
        </div>
      </div>
      <sponsor/>
    </div>
    <div class="loading" v-if="data_loading">
      <loading></loading>
    </div>
    <video-float v-if="video_info.title" :video_info="video_info" @hideVideo="hideVideo"></video-float>
  </main>
</template>

<script>
import Crumbs from "../../components/pc/Crumbs";
import Loading from "../../components/pc/Loading";
import VideoFloat from "../../components/pc/VideoFloat";
import Sponsor from "@/components/pc/Sponsor";
export default {
	name: 'branch',
	data() {
		return {
			query:"",
			branch:[],
			tab:{},
			data_loading:true,
			service_time:0,
			time_list:[],
			now_time:0,
			adv4:[],
			video_info:{},

			live_active:[2,3,5],
			title:"",
			star_list:[],

			tab_index:0,
		}
	},
	components:{
		Loading,Crumbs,VideoFloat,Sponsor
	},
	computed:{
		banner_status(){
			var now_time = this.now_time;
			if(now_time < this.tool.date.strtotime('2026-08-21 14:00:00')){
				return 1;
			}else if(now_time >= this.tool.date.strtotime('2026-08-21 17:30:00')){
				return 3;
			}else{
				return 2;
			}
		},
		crumbs() {
			return {title:"分论坛",min_title:"BREAKOUT SESSION"}
		},
		is_login(){
			return this.util.getAccessToken();
		}
	},
	watch:{
		now_time(newVal,oldVal){
			if(newVal > oldVal && this.util.inArray(newVal,this.time_list)){
				this.getBranch();
			}
		},
		$route(){
			this.checkTab();
			this.setTitle();
		}
	},
	methods: {
		toBanner(){
			if(this.banner_status === 2){
				window.open('https://www.dellemc-solution.com/webinar-dtf/?channelId=4180876&mainId=4180876#/','_blank')
			}
			if(this.banner_status === 3){
				window.open('https://www.dellemc-solution.com/webinar-dtf/?channelId=4180876&mainId=4180876#/','_blank')
			}
		},
		changeTab(item,index){
			if(item.link){
				window.location.href = item.link
			}else{
				this.tab.id = item.id
				this.tab_index = index;
        this.$nextTick(() => {
          this.fuckSister();
        })
			}
		},
		checkTab(){
			this.query = this.$route.query;
			if(this.query.id){
				this.tab = {
					id:this.query.id
				}
			}else{
				this.tab = {
					id:this.branch?.[0]?.id || '',
				}
			}
		},
		setTitle(){
			this.title = "分论坛";
			document.title = "分论坛-2026戴尔科技峰会";
			this.report();
		},
		report(){
			var gioParams = {
				module_pvar: "2021DTF大会",
				category1_pvar:this.$route.meta.category,
				category2_pvar:this.title,
				title_pvar:document.title,
				url_pvar:window.location.href
			}
			gio('page.set', gioParams);
		},
		showVideo(item){
			item.video = item.url;
			this.video_info = item;
		},
		hideVideo(){
			this.video_info = {}
		},
		swiperInit(){
			this.swiper = new Swiper('#swiper-branch',{
				// slidesPerView:this.branch.length > 5 ? 4.5 : 5,
				slidesPerView:4,
				spaceBetween: 30,
				watchOverflow:true,
				slideToClickedSlide:true,
				observer:true,
				observeSlideChildren:true,
			})
		},
		statusText(status){
			var text = ["敬请期待","即将开始","正在直播","已结束","直播回放"];
			return text[status-1];
		},
		toMudu(item,vv = '',i = ''){
			var status = this.sessionStatus(item,vv,i);
			if(!this.tool.array.inArray(this.live_active,status)){
				return false;
			}
			if(item.live_url){
				window.open(item.live_url,'_blank');
			}else{
				var live_code = item.live_code;
				if(Number(item.live_status) === 5){
					live_code = vv.live_code;
				}
				//var url = this.global.MUDU_HOST +live_code;
				if(this.$store.state.user_info.id){
					var router = this.$router.resolve({
						path:"/auth",
						query:{
							live_event:item.live_event,
							live_code:live_code,
							live_type:item.live_type,
							title:item.title,
							branch:2
							//redirect:url
						}
					});
					window.open(router.href, '_blank');
				}else{
					var from = `/auth?live_code=${live_code}&live_type=${item.live_type}&live_event=${item.live_event}&title=${item.title}&branch=2`;
					this.util.showAuth({
						show:true,
						from:from
					});
				}
			}
		},
		inStar(row){
			return  this.star_list.find((item,index)=>{
				return Number(item.topic_id) === Number(row.id)
			})
		},
		star(item,branch = {}){
			if(!this.is_login){
				this.util.showAuth({
					show:true,
					from:"/branch"
				});
			}else{
				this.http.request({
					api:"user/star",
					data:{
						type:2,
						topic_id:item.id,
						branch_id:branch.id || '',
					},
					success:(res)=>{
						this.getStarList();
					}
				})
			}
		},
		getStarList(){
			if(!this.is_login){
				return false;
			}
			this.http.request({
				api:"user/starList",
				data:{
					type:2,
				},
				success:(res)=>{
					this.star_list = res.list;
				}
			})
		},
		sessionStatus(data,item,index){
			if(data.live_status > 0){
				return data.live_status;
			}else{
				var now_time = this.now_time;
				if(now_time < parseInt(item.live_start)){
					if(index == 0){
						if(now_time < parseInt(item.live_start) - 30*60){
							return 1;
						}else{
							return 2;
						}
					}else{
						return 1;
					}
				}else if(now_time >= parseInt(item.live_start) && now_time < parseInt(item.live_end)){
					return 3;
				}else{
					return 4;
				}
			}
		},
		getBranch(){
			this.http.request({
				api:"branch/getBranch",
				success:(res)=>{
					var branch = res.list;
					var time_list = [];
					branch.map((item,index)=>{
						var topic = item.list;
						topic.map((v,i)=>{
							time_list.push(v.live_start);
							time_list.push(v.live_end);
						})
					})
					this.branch = branch;
					this.checkTab();
					this.time_list = time_list;
					this.data_loading = false;

					if(this.tool.other.getUrlParams('timer') == 'local'){
						this.now_time = Math.floor(new Date().getTime()/1000);
					}else{
						this.now_time = res.service_time;
					}

					this.$nextTick(()=>{
						this.swiperInit();
						this.refresh();
						this.util.showBottom(true);
            this.fuckSister();
					})
				}
			})
		},
		checkMudu(){
			//https://dtf.dellemc-solution.com/#/auth?live_code=m9g528b7&redirect=http://dtf.evp.mudu.tv/watch/m9g528b7
			var branch_code = this.util.getUrlParams('branch_code');
			if(!branch_code){
				return false;
			}
			var url = this.global.MUDU_HOST+branch_code;
			if(this.$store.state.user_info.id){
				this.$router.replace({
					path:"/auth",
					query:{
						live_code:branch_code,
						redirect:url
					}
				})
			}else{
				var from = "/auth?live_code="+branch_code+"&redirect="+url
				this.util.showAuth({
					show:true,
					from:from
				});
			}
		},
		refresh(){
			this.timer = setInterval(()=>{
				var myDate = new Date();
				this.now_time = parseInt(myDate.getTime()/1000)
			},1000)
		},
		getVideoList(){
			this.http.request({
				api:"video/getVideoList",
				data:{
					type:4,
				},
				success:(res)=>{
					this.adv4 = res.list;
				}
			})
		},
    fuckSister() {
      const dom = document.querySelectorAll(".list.active .fuck-your-sister.active")[0];
      if (dom) {
        const t = dom.getBoundingClientRect().top - 90;
        document.body.scrollTop = document.documentElement.scrollTop = t;
      }
    },
	},
	mounted() {
		this.query = this.$route.query;
		this.setTitle();
		this.getBranch();
		this.getVideoList();
		this.checkMudu();
		this.getStarList();
	},
	destroyed() {
		clearInterval(this.timer);
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.wrap{padding-bottom: 30px;padding-top: 30px;
    .result{width: 1220px;margin: 0 auto 0;
        .branch{
			.swiper-container{padding: 10px 30px;
				.item{height:140px; margin-right: 30px;border-radius: 5px; box-shadow: 0 0 .1rem .02rem rgba(0,0,0,.1); position: relative;cursor: pointer;text-align: center;transition: all .3s ease;background-repeat: no-repeat;background-position:right center;background-size: auto 100%; background-color: #EEEEEE;
					.cen{display: inline-block;
						.middle{text-align: center;transition: all .3s ease;height:140px;
							.icon{width: 50px;height:70px;display: block;margin: 0 auto;
								img{width: 100%;height:100%;object-fit: contain;}
							}
							.icon-a{display: none;}
							.tit{color:#2d576f;font-size: 16px;line-height: 36px;}
						}
					}
				}
				.item.active{transition: all .3s ease;background: url("~@/assets/image/b44.jpg") no-repeat right center #1A56C6;background-size: auto 100%;
					.cen{
						.middle{
							.icon{display: none;}
							.icon-a{display: block;}
							.tit{color:#ffffff;}
						}
					}
				}
				.item:nth-last-child(1){margin-right: 0;}
			}
        }
		.title-box{font-size: 40px;color:#0672cb;padding: 20px 0;margin-bottom: 10px;
			span{margin-right: 20px;}
		}
		.session{margin-top: 20px;padding: 0 10px;
			.list{display: none;
				.description{padding-top: 10px;text-indent: 50px; font-size: 14px;line-height: 24px;color:#444;background: url("~@/assets/image/2021/19.png") no-repeat top left;background-size: 30px;}
				.box{margin-top: 30px;
					.item{position: relative;display: flex;flex-wrap: wrap;
						.time-box{display: flex;flex-direction: column;width: 160px;
							.line{position: relative;}
							.line::after{content: "";display: block;position: absolute;left:10px;top:0;width: 1px;height:100%;background: #979797;}
							.line-1{height:16px;}
							.time{font-size: 18px;height:40px;line-height: 40px; font-weight: bold;background:url("~@/assets/image/2021/14.png") no-repeat left center;background-size:24px;padding-left: 40px;}
							.line-2{flex: 1;};
						}
						.info-box{padding-bottom: 18px;flex: 1;
							.info{padding: 25px;background: #fff;box-shadow: 0 0 10px 2px rgba(0,0,0,.1);position: relative;
								.title{font-size: 18px;font-weight: bolder;color:#1A1A1A; font-family: Roboto,'Source Han Sans SC','思源黑体','Microsoft YaHei','微软雅黑',sans-serif;}
								.speaker{font-size: 14px;color:#808080;margin-top: 10px;
									.ll{overflow: hidden;display: flex;
										span,i{display: block;float: left;}
										span:nth-child(1){min-width: 45px;display: inline-block;text-align: justify;text-align-last: justify;}
										i{padding: 0 10px;}
										span:nth-last-child(1){flex: 1;}
									}
								}
								.status-box{position: absolute;bottom:0;right:0;display: flex;
									.status{width: 110px;height:40px;text-align: center;line-height: 40px;background:#9F9F9F;color:#fff;border-right: 1px solid #fff;
										p{padding-left: 20px;background: url("~@/assets/image/2021/16.png") no-repeat left center;background-size: 12px;display: inline-block;}
									}
									.status.active{background:#0672cb;cursor: pointer;}
									.star{width: 110px;height:40px;text-align: center;line-height: 40px;background:#0672cb;color:#fff;transition: all .3s ease;
										p{padding-left: 22px;background: url("~@/assets/image/2022/10.png") no-repeat left center;background-size: 17px;display: inline-block;transition: all .3s ease;}
										p::after{content: "收藏"}
									}
									.star.active{background:#9F9F9F;cursor: pointer;transition: all .3s ease;
										p{background-image: url("~@/assets/image/2022/11.png");background-size: 17px;transition: all .3s ease;}
										p::after{content: "已收藏"}
									}
									.star.active:hover{background:rgba(0,118,206,.7);transition: all .3s ease;
										p::after{content:"取消收藏"}
									}
								}
							}
						}
					}
					.item.active{cursor: pointer;
						.time{background: url("~@/assets/image/2024/icon06.png") no-repeat left center;background-size: 24px;}
					}
					.item:nth-last-child(1){
						.info-box{padding-bottom: 0;}
					}
				}
			}
			.list.active{display: block;}
		}
    }
	.common-title{overflow:hidden;font-size: 36px;line-height: 47px;color:#C8C9C7;padding: 35px 0;
		.title{color:#41B6E6;}
		.en-title{margin-left: 10px;font-weight: 100;}
	}
	.s5{display:none;clear: both;padding: 17px 0 70px;position: relative;
		.center{width: 1220px;margin: 0 auto;
			.b1{width: 126px;height:126px;position: absolute;top:153px;left:-14px;background: url("~@/assets/image/2021/10.png") no-repeat center center;background-size: contain;}
			.common-title{margin-left: 10px;}
			.content{
				.list{overflow: hidden;padding:10px;
					.item{float: left;width: 285px;margin-right: 20px;text-align: left;transition: all .3s ease;background: #fafafa;box-shadow: 0 0 10px 2px rgb(0,0,0,.03);
						.image-box{padding: 15px;
							.image{height:160px;background:url("~@/assets/image/11.png") no-repeat center center;background-size: cover;position: relative;
								.play{width: 45px;height:45px;position: absolute;top:50%;left:50%;background: url("~@/assets/image/2021/7.png") no-repeat left center;background-size: contain;margin-left: -22px;margin-top: -22px; cursor: pointer;z-index: 2;}
							}
							.image::after{content: "";display: block;position: absolute;top:0;left:0;width: 100%;height:100%; background: rgba(0,0,0,.5);z-index: 1;}
						}
						.info{border: 1px solid #fafafa;padding:0 15px 15px;box-sizing: border-box;
							.tit{font-size: 14px;line-height: 19px;color:#41B6E6;
								i{font-weight: bold;margin-left: 2px;}
							}
							.min-tit{font-size: 16px;color:#1A1A1A;line-height: 24px;min-height:48px; -webkit-line-clamp: 2;}
						}
					}
					.item:hover{box-shadow: 0 0 10px 2px rgb(0,118,206,.3);}
					.item:nth-last-child(1){margin-right: 0;}
				}
			}
			.more{text-align: center;margin-top: 30px;
				.btn{display: inline-block;font-size: 14px;color:#fff;background:  linear-gradient(90deg,#47ced9,#357b8f); padding: 10px 20px ;border-radius:5px;cursor: pointer;transition: all .3s ease;text-align: center;
					span{display: inline-block;padding-right: 16px; background:url("~@/assets/image/2021/9_a.png") no-repeat right center;background-size:auto 12px;}
				}
				.btn:hover{font-weight: bold; transition: all .3s ease;}
			}
		}
	}
}
.footer{height:300px;line-height: 300px;text-align: center;color:#999;font-size: 16px;}
.loading{margin: 50px auto;}
</style>

